export default __webpack_public_path__ + "static/media/img07.cfaff493.jpg";